import styled from 'styled-components';
import Button from 'src/components/core/button';
import { KIOSK_PRO_MEDIA } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';

export const PhoneNumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  gap: 72px;

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    gap: 56px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    gap: 48px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscape} {
    gap: 36px;
  }
`;

export const Title = styled.h1`
  font-size: 56px;
  font-weight: 700;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 40px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 36px;
  }
`;

export const PhoneNumberPadWrapper = styled.div`
  width: 380px;
  margin: 0 auto;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 260px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    max-width: 280px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscape} {
    margin: 0;
    width: auto;
  }
`;

export const PhoneNumberPadGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 8px;

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    gap: 6px;
    margin-bottom: 6px;
  }
`;

export const BottomRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    gap: 8px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    gap: 6px;
  }

  > :first-child {
    grid-column-start: 2;
    justify-self: end;
    margin: 0;
  }

  > :last-child {
    justify-self: start;
    margin: 0;
  }
`;

export const Number = styled.button`
  width: 112px;
  height: 112px;
  border: 2px solid ${({ theme }) => theme.customized.colors.buttonsLinks};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  margin: 0 auto;
  font-size: 36px;
  font-weight: bold;
  cursor: pointer;
  display: grid;
  place-items: center;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 80px;
    height: 80px;
    font-size: 24px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    width: 64px;
    height: 64px;
    font-size: 24px;
  }
`;

export const PhoneNumberInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const PhoneNumberDisplay = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const PhoneNumberText = styled.span`
  font-size: 112px;
  font-weight: 700;
  white-space: pre;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 80px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 64px;
  }
`;

export const PhoneNumberPadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 36px;

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth}, ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    gap: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: 24px;
  }
`;

export const ReadOnlyInput = styled.input`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
  margin: 0;
  border: 0;
  opacity: 0;
  cursor: text;
`;

export const BlinkingCursor = styled.span`
  font-size: 112px;
  font-weight: bold;
  color: #000;
  animation: blink 1s infinite;
  pointer-events: none;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 80px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 64px;
  }

  @keyframes blink {
    0%,
    50% {
      opacity: 1;
    }
    51%,
    100% {
      opacity: 0;
    }
  }
`;

export const EnterButton = styled(Button)`
  display: inline-block;
  padding: 36px 56px;
  font-weight: 700;
  font-size: 36px;
  width: 396px;
  height: 108px;
  border: none;
  background-color: ${({ theme }) => theme.customized.colors.buttonsLinks};
  color: ${({ theme }) => theme.colors.white};
  text-align: center;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.blueGrey?.[80] ?? '#bccad2'};
    color: ${({ theme }) => theme.colors.white};
    cursor: not-allowed;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth}, ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    font-size: 28px;
    padding: 28px 40px;
    width: 320px;
    height: 84px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 24px;
    padding: 24px 36px;
    width: 280px;
    height: 72px;
  }
`;
